import React, { createContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

const LineItemReorderActionStatusContext = createContext(null);

/**
 * This context manages the state of the given reorder "action" (i.e. add to cart, edit design & reorder)
 */
const LineItemReorderActionStatusContextProvider = ({ children }) => {
  const [action, setAction] = useState('');
  const [addToCartSuccess, setAddToCartSuccess] = useState(false);
  const [addToCartFailure, setAddToCartFailure] = useState(false);
  const [designUpdateInProgress, setDesignUpdateInProgress] = useState(false);
  const [productUnavailableFailure, setProductUnavailableFailure] =
    useState(false);
  const [docConversionFailure, setDocConversionFailure] = useState(false);
  const [genericFailure, setGenericFailure] = useState(false);
  const [altDocId, setAltDocId] = useState('');

  // Resets the state to track the currently engaged action
  const resetReorderActionFeedback = onClickAction => {
    setAction(onClickAction || '');
    setAddToCartSuccess(false);
    setAddToCartFailure(false);
    setDesignUpdateInProgress(false);
    setProductUnavailableFailure(false);
    setDocConversionFailure(false);
    setGenericFailure(false);
    setAltDocId('');
  };

  const lineItemReorderActionStatusContextValues = useMemo(
    () => ({
      action,
      addToCartSuccess,
      setAddToCartSuccess,
      addToCartFailure,
      setAddToCartFailure,
      designUpdateInProgress,
      setDesignUpdateInProgress,
      resetReorderActionFeedback,
      productUnavailableFailure,
      setProductUnavailableFailure,
      docConversionFailure,
      setDocConversionFailure,
      genericFailure,
      setGenericFailure,
      altDocId,
      setAltDocId,
    }),
    [
      action,
      addToCartFailure,
      addToCartSuccess,
      altDocId,
      designUpdateInProgress,
      docConversionFailure,
      genericFailure,
      productUnavailableFailure,
    ]
  );

  return (
    <LineItemReorderActionStatusContext.Provider
      value={lineItemReorderActionStatusContextValues}
    >
      {children}
    </LineItemReorderActionStatusContext.Provider>
  );
};

LineItemReorderActionStatusContextProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export {
  LineItemReorderActionStatusContext,
  LineItemReorderActionStatusContextProvider,
};
